import { currencyToNumber } from '@iwoca/orion';
import * as yup from 'yup';

import {
  formatLoanAmountUK,
  MAX_LOAN_AMOUNT_UK,
  MIN_LOAN_AMOUNT_UK,
  TLoanDurationValueUK,
  TLoanPurposeValueUK,
} from './loanOptions';

export const amountSchemaUK = yup.object().shape({
  amount: yup
    .string()
    .required('Loan amount required')
    .test(
      'minCurrencyAmount',
      `Between ${formatLoanAmountUK(MIN_LOAN_AMOUNT_UK)} and ${formatLoanAmountUK(MAX_LOAN_AMOUNT_UK)}`,
      (value) => {
        const numericValue = currencyToNumber(value, {
          currencySymbol: true,
          locale: 'en-GB',
          minorUnits: false,
        });
        if (!numericValue) return false;
        return (
          numericValue >= MIN_LOAN_AMOUNT_UK &&
          numericValue <= MAX_LOAN_AMOUNT_UK
        );
      },
    ),
});

export const loanDetailsSchemaUK = amountSchemaUK.shape({
  loanDuration: yup
    .string<TLoanDurationValueUK>()
    .required('Loan duration required'),
  loanPurpose: yup
    .string<TLoanPurposeValueUK>()
    .required('Loan purpose required'),
});
